import React, { lazy, Suspense } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { AppConfig } from "../helpers";
import WithRouter from "./WithRouter";

import LoadingImg from "../screens/Loading/LoadingImg";
import useFirebaseMessaging from "../firebase/firebase";

const Sport = lazy(() => import("../screens/sport/Sport"));
const Home = lazy(() => import("../screens/HomePage/Home"));
const Live = lazy(() => import("../screens/live/Live"));
const Virtual = lazy(() => import("../screens/virtual/Virtual"));
const ContactUs = lazy(() => import("../screens/contactUs/ContactUs"));
const Fixture = lazy(() => import("../screens/fixture/Fixture"));
const SlotMachines = lazy(() => import("../screens/slotMachines/SlotMachines"));
const MyAccount = lazy(() => import("../screens/myAccount/MyAccount"));
const Document = lazy(() => import("../screens/document/Document"));

const EmailValidate = lazy(() =>
  import("../screens/emailValidate/emailValidate")
);
const VerifyUserEmail = lazy(() =>
  import("../screens/verifyUserEmail/VerifyUserEmail")
);
const StatisticsPage = lazy(() =>
  import("../screens/statistics/StatisticsPage")
);
const Casino = lazy(() => import("../screens/casino/Casino"));
const loginAndRegistration = lazy(() =>
  import("../screens/loginAndRegistration/loginAndRegistration")
);
const SlotMobileGameScreen = lazy(() =>
  import("../screens/SlotMobileGame/SlotMobileGameScreen")
);
const SpinAndWinWheel = lazy(() =>
  import("../screens/spinAndWinWheel/SpinAndWinWheel")
);
const SpinAndWinWheelV1 = lazy(() =>
  import("../screens/SpinAndWinWheelV1/SpinAndWinWheelV1")
);
const WorldCupScreen = lazy(() => import("../screens/worldCup/WorldCupScreen"));
const Maintenance = lazy(() => import("../screens/maintenance/Maintenance"));
const DownloadApp = lazy(() => import("../screens/DownloadApp/DownloadApp"));
const Promos = lazy(() => import("../screens/promos/Promos"));
const VirtulaSports = lazy(() =>
  import("../screens/virtulaSports/VirtulaSports")
);
const LuckyNumbers = lazy(() => import("../screens/LuckyNumbers/LuckyNumbers"));
const WorkWithUs = lazy(() => import("../screens/workWithUs/WorkWithUs"));
// const LuckyNumbersKiosk = lazy(() =>
//   import("../screens/luckyNumbersKiosk/LuckyNumbersKiosk")
// );
const Slots = lazy(() => import("../screens/slots/Slots"));
const BannersKiosk = lazy(() => import("../screens/bannersKiosk/BannerKiosk"));
const SlotsBonusGames = lazy(() =>
  import("../screens/slotBonus/SlotsBonusGames")
);

const Routes = (props) => {
  const { store, history } = props;
  const deviceToken = useFirebaseMessaging(history, store);
  deviceToken && localStorage.setItem("firebaseDeviceToken", deviceToken);
  const { location } = history;
  const hasQueryParams = location.search.includes("?");
  return (
    <ConnectedRouter store={store} history={history}>
      <WithRouter>
        {/* <Route
          exact
          path="/"
          render={() => <Redirect to="/sport/6/1/Soccer" />}
        /> */}

        <Suspense fallback={<LoadingImg />}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/sport/:feed/:sport/:sportName" component={Sport} />
            <PrivateRoute path="/promos" component={Promos} store={store} />
            {/* <Route exact path="/SpinAndWinWheel" component={SpinAndWinWheel} /> */}
            <Route exact path="/spinandwinwheel" component={SpinAndWinWheel} />
            <Route
              exact
              path="/spinandwinwheelmini"
              component={SpinAndWinWheelV1}
            />
            <Route path="/virtual-sports" component={VirtulaSports} />
            <Route path="/live/:feed/:sport/:sportName" component={Live} />
            <Route
              path="/virtual/:feed/:sport/:sportName?"
              component={Virtual}
            />

            <PrivateRoute
              path="/casino/:feed/:sport/:sportName?"
              component={Casino}
              store={store}
            />

            <Route exact path="/contact" component={ContactUs} />
            <Route path="/slots1" component={SlotMachines} />
            {AppConfig.ShowSignInAndRegistersBtn && (
              <Route exact path="/fixture" component={Fixture} />
            )}
            <Route path="/emailvalidate/:id" component={EmailValidate} />
            <Route path="/document/:page" component={Document} />
            <Route path="/statistics" component={StatisticsPage} />
            <Route
              exact
              path="/login-registration/:indicator"
              component={loginAndRegistration}
            />
            <Route exact path="/slot/game" component={SlotMobileGameScreen} />
            <Route exact path="/download/app" component={DownloadApp} />
            <Route exact path="/worldcup/:id?" component={WorldCupScreen} />
            <Route path="/verifyEmail" component={VerifyUserEmail} />
            <PrivateRoute
              path="/account/:page?"
              store={store}
              component={MyAccount}
            />
            <Route exact path="/maintenance" component={Maintenance} />
            {/* <PrivateRoute
            path="/lucky-numbers/:feed/:sport/:page"
            component={LuckyNumbers}
            store={store}
          /> */}
            <Route path="/work-with-us" component={WorkWithUs} />
            {/* <Route
            path="/luckyNumbersKiosk/:feed/:sport"
            component={LuckyNumbersKiosk}
          /> */}
            <Route path="/bannerKiosk/:GroupId" component={BannersKiosk} />
            <Route path="/slots/:categoryId" component={Slots} />
            <Route path="/slotBonusGames" component={SlotsBonusGames} />
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </Suspense>
      </WithRouter>
    </ConnectedRouter>
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  let state;
  let condition;
  state = rest.store.getState();
  if (rest.path == `/account/:page?`) {
    condition = state.auth.signedIn;
  } else {
    if (state.general.configuration && localStorage.getItem("headerTabs")) {
      const headerTabs = JSON.parse(localStorage.getItem("headerTabs"));
      if (rest.path.includes("promo")) {
        condition =
          headerTabs.filter((tab) => tab.headerTabsID == 7).length > 0;
      } else if (rest.path.includes("casino")) {
        condition =
          headerTabs.filter(
            (tab) => tab.headerTabsID == 9 || tab.headerTabsID == 5
          ).length > 0;
      } else if (rest.path.includes("lucky")) {
        condition =
          headerTabs.filter((tab) => tab.headerTabsID == 8).length > 0;
      }
    } else {
      condition = false;
    }
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        condition ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/sport/6/1/soccer",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
export default Routes;
